import { createRouter, RouterProps, RouterProvider as RouterProviderTanstack } from '@tanstack/react-router';
import PendingComponentLoader from 'common/components/pendingComponentLoader';
import { FC } from 'react';
import { routeTree } from '../../../routeTree.gen';
import { RouterErrorDisplay } from './router-error-display';
import { ExternalPayloadState } from './types';

export const router = createRouter({
  routeTree,
  defaultPendingComponent: PendingComponentLoader,
  defaultErrorComponent: ({ error, reset }) => <RouterErrorDisplay error={error} reset={reset} />,
  defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
  interface HistoryState {
    externalPayload?: ExternalPayloadState;
  }
}

export const RouterProvider: FC<RouterProps> = ({ router }) => <RouterProviderTanstack router={router} />;
